export default {"src":"/_next/static/media/InProgress.5d2927ba.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};